import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMelasmaGlyphSecondary from './svgs/MelasmaGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var melasmaGlyph = (props => useIcon(null, SvgMelasmaGlyphSecondary, props));

export { melasmaGlyph as default };
